export const URL_PREFIX = '/__saasweb__/spam-shield/'
export const API_PREFIX = URL_PREFIX + 'api/v1/'
export const CSS_PATH = import.meta.env.BASE_URL + 'index.css'
export const APP_ELEMENT = 'saasweb-spam-shield'
export const COMMON_PREFIX = 'saasweb-spam-shield-'
export const ID_PREFIX = COMMON_PREFIX + 'v1-'
export const IPC_VERSION = 1;
export const HIDDEN_FIELD_NAME = '__swss_pow__';
